//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex' // 引入mapState
// import Bscroll from 'better-scroll'
export default {
  data () {
    return {
      searchCountry: '', // 搜索绑定
      seleLetter: 'A', // 选中的字母
      // goodMenu: ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'J', 'K', 'L', 'M', 'N', 'P', 'R', 'S', 'T', 'W', 'X', 'Y', 'Z'],
      // goodMenuEn: ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'Y', 'Z'],
      goodMenletter: (this.$store.state.LanguageCode != 'zh-cn' && this.$store.state.LanguageCode != 'zh-tw' && this.$store.state.LanguageCode != 'zh-hk') ? ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'Y', 'Z'] : ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'J', 'K', 'L', 'M', 'N', 'P', 'R', 'S', 'T', 'W', 'X', 'Y', 'Z'],
      countries: (this.$store.state.LanguageCode != 'zh-cn' && this.$store.state.LanguageCode != 'zh-tw' && this.$store.state.LanguageCode != 'zh-hk') ? require('~/static/json/areaCodeEn.json') : require('~/static/json/areaCodeCN.json'), // 中文国家列表
      searchData: [], // 搜索出来的数据
      scrollY: 0, // 获取实时滚动位置
      heightList: [] // 获取每一个li的高度
    }
  },
  computed: {
    ...mapState(['usergetCountry']),
    currentIndex () { // 英文字母当前选中项
      const index = this.heightList.findIndex((item, index) => this.scrollY >= this.heightList[index] && this.scrollY < this.heightList[index + 1])
      return index > 0 ? index : 0
    }
  },
  watch: {
    searchCountry (newValue) { // 搜索后的列表
      const patt = new RegExp(newValue, 'i')
      const coulist = []
      if (!newValue) return
      this.countries.forEach((item) => {
        item.data.forEach((e) => {
          coulist.push(e)
        })
      })
      this.searchData = coulist != [] && coulist.filter((i) => {
        return (patt.test(i.name) || i.code.search(newValue) != -1)
      })
    }
  },
  created () {
    // console.log(this.countries)
  },
  mounted () {
    // this.$nextTick(() => {
    //   this.getHeight()
    // })
  },
  methods: {
    countryChange (i) { // 点击国家切换
      this.$store.commit('setuserCountry', i) // 更换点击的国家
      this.$emit('countryChange') // 关闭国家弹框
    },
    // 国家滚动
    cyScroll () {
      this.scrollY =
                this.$refs.goodList.scrollTop || this.$refs.goodList.scrollTop
    },
    _scrollInit () { // 初始化滚动
    },
    getHeight () { // 计算每一个英文首字母的列表高度
      const lis = this.$refs.rItem // 获取每一个li的高度
      let height = 0 // heightList的第一个元素为0
      this.heightList.push(height)
      lis.forEach((item) => { // 之后的高度即为当前li的高度加上之前面li的高度和
        height += item.clientHeight
        this.heightList.push(height)
      })
    },
    selectLeft (index) { // 字母点击滚动
      const rItem = this.$refs.rItem
      const el = rItem[index]
      this.seleLetter =
                el.getAttribute('data-num')
      const goodind = this.goodMenletter.findIndex((item, ind) => {
        return item == this.seleLetter ? ind : ''
      })
      this.$nextTick(() => {
        this.$refs.goodList.scrollTop = this.heightList[goodind]
      })
    }
  }
}
